@if ((productChange$ | async); as productChange) {
  <div class="flex flex-col pb-6">

    <div class="flex items-center gap-x-4 py-6 px-6 md:w-[var(--document-card-container-width)] md:mx-auto">
      <!-- TODO sobald dacks-content-header auch mehrzeilig sein kann, die h1 damit umsetzen -->
      <h1 class="mu-heading-3 md:mu-heading-2 text-petrol-650">{{ productChange.title }}</h1>
      <button mat-button class="hidden md:inline-flex ml-auto flex-shrink-0" aria-label="Teilen per Mail" color="light" (click)="shareByMail(productChange)">
        <mat-icon svgIcon="fi-teilen-20"></mat-icon>
        <span>{{ 'common.caption_share' | translate }}</span>
      </button>
      <button mat-fab class="md:hidden ml-auto flex-shrink-0" aria-label="Teilen per Mail" color="light" (click)="shareByMail(productChange)">
        <mat-icon svgIcon="fi-teilen-20"></mat-icon>
      </button>
    </div>

    @if (isSmallScreen$ | async) {
      <div class="flex-1 min-h-0 p-6 bg-white">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>
    } @else {
      <div class="flex flex-col items-center flex-1 min-h-0 px-6">
        <mat-card class="w-full mx-4 md:w-[var(--document-card-container-width)] max-w-[var(--document-card-container-width)] flex flex-col flex-1 min-h-0">
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </mat-card>
      </div>
    }
  </div>

  <ng-template #content>
    <div>
      @if (productChange.deliveryDate) {
        <div class="flex flex-row flex-nowrap font-medium mb-4"
        >
          @if (productChange.onlineProduct) {
            <div>
              {{ 'product-change-details.contained_in_month' | translate }} {{ productChange.deliveryDate | date:dateTranslationMonth }}
            </div>
          } @else {
            <mat-icon class="flex-none h-4 w-4 mt-1 mr-1.5" svgIcon="fi-kalender-20" aria-hidden="true"></mat-icon>
            @if ((deliveryProductsRoute$ | async); as deliveryProductsRoute) {
              @if (!!deliveryProductsRoute) {
                <div>
                  <a routerLink="{{deliveryProductsRoute}}" id="a_contained_in" tabindex="0">
                    {{ 'product-change-details.contained_in' | translate }} {{ productChange.deliveryDate | date:dateTranslation }}
                  </a>
                </div>
              } @else {
                <div>
                  {{ 'product-change-details.contained_in' | translate }} {{ productChange.deliveryDate | date:dateTranslation }}
                </div>
              }
            } @else {
              <div>
                {{ 'product-change-details.contained_in' | translate }} {{ productChange.deliveryDate | date:dateTranslation }}
              </div>
            }
          }
        </div>
      }
      @if (isValidDeliveryInfos(productChange)) {
        <mat-card
          class="flex flex-col sm:flex-row p-4 sm:p-6 gap-3 sm:gap-6 sm:justify-between mb-4 md:mb-6 bg-coldgray-50 box-shadow-none"
          [ngClass]="(productChange.deliveryType === DeliveryType.ServiceRelease ||
            productChange.deliveryType === DeliveryType.Hotfix ||
            productChange.deliveryType === DeliveryType.ServiceReleaseAndHotfix) &&
            productChange.deliveredByRdt ? 'max-w-[47.8125rem]' : 'max-w-[32rem]'">
          @if ((productChange.deliveryType === DeliveryType.ServiceRelease ||
            productChange.deliveryType === DeliveryType.Hotfix ||
            productChange.deliveryType === DeliveryType.ServiceReleaseAndHotfix) && productChange.deliveredByRdt) {
            <div>
              <p class="font-medium">{{ 'product-change-details.header_precondition' | translate }}</p>
              @if (productChange.deliveryBases) {
                <p class="font-normal">
                  <myupdates-delivery-bases
                    [deliveryBases]="productChange.deliveryBases"></myupdates-delivery-bases>
                </p>
              }
              @if (!(productChange.deliveryBases)) {
                <p class="font-normal">-</p>
              }
            </div>
          }
          <div>
            <p
              class="font-medium whitespace-nowrap">{{ 'product-change-details.header_obtainable' | translate }}</p>
            @if (productChange.deliveryType === DeliveryType.ServiceRelease ||
            productChange.deliveryType === DeliveryType.Hotfix ||
            productChange.deliveryType === DeliveryType.ServiceReleaseAndHotfix) {
              <p class="font-normal">{{
                  productChange.deliveredByRdt |
                    obtainable: productChange.deliveredByDownload | arrayToString: ', '
                }}</p>
            } @else {
              <p class="font-normal">{{ 'product-change-details.header_main_release_obtainable' | translate }}</p>
            }
          </div>
          <div>
            <p class="font-medium">{{ 'product-change-details.header_trafo_required' | translate }}</p>
            <p class="font-normal">{{ productChange.dataTransformation | yesNo }}</p>
          </div>
        </mat-card>
      }
    </div>
    @if ((deliveryError$ | async)) {
      <myupdates-error-box class="error-box-dimmed-style"
                           [errorTitle]="errorTitle"
                           [errorText]="errorText">
      </myupdates-error-box>
    }
    <div class="max-w-[51.5rem]">
      <myupdates-html-viewer class="document-viewer-base document-viewer-product" [documentId]="productChange.documentId">
      </myupdates-html-viewer>
    </div>
    @if ((contentError$ | async)) {
      <myupdates-error-box class="error-box-dimmed-style"
                           [errorTitle]="errorTitle"
                           [errorText]="errorText">
      </myupdates-error-box>
    }
  </ng-template>
}
@else {
  <div class="mx-4">
    @if ((errorInfo$ | async)) {
      <myupdates-error-box class="error-box-dimmed-style"
                           [errorTitle]="errorTitle"
                           [errorText]="errorText">
      </myupdates-error-box>
    } @else {
      <mat-spinner class="m-auto text-petrol-500"></mat-spinner>
    }
  </div>
}

